/** PURE_IMPORTS_START .._.._Observable,.._.._operator_sampleTime PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { sampleTime } from '../../operator/sampleTime';
Observable.prototype.sampleTime = sampleTime;
//# sourceMappingURL=sampleTime.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/sampleTime.js
// module id = ./node_modules/rxjs/_esm5/add/operator/sampleTime.js
// module chunks = vendor